import { cn } from "@babybjorn/ui";
import type { FC, ReactNode } from "react";
import Button from "../../../../components/general/Button";
import * as s from "./FooterBlockItem.module.scss";

type FooterBlockItemProps = {
	type: "email" | "cta";
	emailForm?: ReactNode;
	headline?: string;
	content?: string;
	buttonText?: string;
	href?: string;
	target?: string | null;
};

const FooterBlockItem: FC<FooterBlockItemProps> = ({
	type,
	emailForm,
	headline,
	content,
	buttonText,
	href,
	target,
}) => {
	return (
		<div className={cn(s.container, { [s.cta]: type === "cta" })}>
			<div className={s.contentContainer}>
				{headline && <h2 className={s.headline}>{headline}</h2>}
				{content && <p className={s.content}>{content}</p>}
			</div>
			{type === "email" && emailForm ? (
				<div className={s.input}>{emailForm}</div>
			) : (
				<div>
					<Button
						variant="secondary"
						iconLeft
						icon="message"
						type="button"
						label={buttonText}
						fullWidth
						href={href}
						target={target ?? undefined}
					/>
				</div>
			)}
		</div>
	);
};
export default FooterBlockItem;
